module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/vector-bg.5d4c4ee9.svg";